var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinAdmin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83301 9.49998H8.83301V18.5H5.83301V9.49998ZM10.333 9.49998H13.333V10.5971C14.2857 10.027 15.4148 9.49998 16.333 9.49998C18.333 9.49998 18.833 11.5 18.833 11.5V18.5H15.833V12.5C15.4454 11.3371 14.4567 11.3763 13.333 12.3845V18.5H10.333V9.49998ZM7.33301 5.5C8.16142 5.5 8.83301 6.17156 8.83301 7C8.83301 7.82841 8.16142 8.5 7.33301 8.5C6.50457 8.5 5.83301 7.82841 5.83301 7C5.83301 6.17156 6.50457 5.5 7.33301 5.5Z",
    fill: "#3C3C43",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinAdmin);
export default __webpack_public_path__ + "static/media/linkedin-admin.7b6736c15cbbf14ce7ff2ca818264a69.svg";
export { ForwardRef as ReactComponent };